<li
  class="breadcrumb-item"
  [class.selected]="selected"
  [class.inactive]="inactive"
  [attr.aria-current]="selected ? 'page' : null"
  >
  <div class="breadcrumb-content">
    <!-- Selected breadcrumb with typography -->
    @if (selected) {
      <hyperkit-typography
        variant="body"
        size="sm"
        align="left"
        color="tertiary"
        >
        {{ text }}
      </hyperkit-typography>
    }

    <!-- Unselected breadcrumb with link -->
    @if (!selected) {
      <hyperkit-link
        class="breadcrumb-text"
        [routerLink]="link"
        [color]="'primary'"
        [variant]="'emphasized'"
        [active]="false"
        size="sm"
        align="center"
        [attr.role]="!link ? 'button' : null"
        [attr.tabindex]="!link ? 0 : null"
        (click)="!link ? clicked.emit() : null"
        (keydown)="!link ? onKeydown($event) : null"
        [text]="text"
      ></hyperkit-link>
    }
  </div>
</li>
